export default "__VITE_ASSET__D877kpbo__"